// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../../services/apiService/apiService';

export const depositedSlipDashboardActions = {
  SET_DASHBOARD_DATA: 'SET_DASHBOARD_DATA',
  UPDATE_PAGE_NUMBER: 'UPDATE_PAGE_NUMBER',
  SET_DEPOSIT_SLIP_DETAILS_FOR_MODAL: 'SET_DEPOSIT_SLIP_DETAILS_FOR_MODAL'
};

export const getDashboardDataAction = (data: Object) => ({
  type: depositedSlipDashboardActions.SET_DASHBOARD_DATA,
  payload: data
});

export const setDepositSlipDetailsForModalAction = (data: Object) => ({
  type: depositedSlipDashboardActions.SET_DEPOSIT_SLIP_DETAILS_FOR_MODAL,
  payload: data
});

export const updatePageNumber = payload => ({
  type: depositedSlipDashboardActions.UPDATE_PAGE_NUMBER,
  payload
});

const errorMsg = 'Could not get deposit slip';

export const getDashboardData = obj => (dispatch: Function, getState) => {
  const { depositSlipDashboardState } = getState();

  dispatch(
    getDashboardDataAction({
      isLoading: true,
      isLoaded: false
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getDepositSlipDetails',
    method: 'GET',
    replaceParamsArr: [
      { key: 'startTime', val: obj.startDate },
      { key: 'endTime', val: obj.endDate },
      { key: 'depositSlipType', val: obj.type },
      { key: 'pageNo', val: depositSlipDashboardState.pageNumber + 1 },
      { key: 'pageSize', val: depositSlipDashboardState.pageSize },
      { key: 'cnotes', val: obj.cnotes }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            dashboardData: res.payload,
            totalElements: res.totalElements,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to getDashboardDataAction ', res);
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            dashboardData: [],
            totalElements: 0,
            error: res.errorMessage || errorMsg
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to getDashboardDataAction ', res);
      dispatch(
        getDashboardDataAction({
          isLoading: false,
          isLoaded: true,
          dashboardData: [],
          totalElements: 0,
          error: res.errorMessage || errorMsg
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while getDashboardDataAction ', res);
      dispatch(
        getDashboardDataAction({
          isLoading: false,
          isLoaded: true,
          dashboardData: [],
          totalElements: 0,
          error: errorMsg
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getDepositSlipDetailForModal = obj => (dispatch: Function) => {
  dispatch(
    setDepositSlipDetailsForModalAction({
      isLoading: true,
      isLoaded: false,
      depositSlipDetail: [],
      error: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getDepositSlipDetailsForModal',
    pathVariables: [{ key: '{id}', val: obj.id }],
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          setDepositSlipDetailsForModalAction({
            isLoading: false,
            isLoaded: true,
            depositSlipDetail: res.payload,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line
        console.log('Failure to setDepositSlipDetailsForModalAction ', res);
        dispatch(
          setDepositSlipDetailsForModalAction({
            isLoading: false,
            isLoaded: true,
            depositSlipDetail: [],
            error: res.errorMessage || errorMsg
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line
      console.log('Failure to setDepositSlipDetailsForModalAction ', res);
      dispatch(
        setDepositSlipDetailsForModalAction({
          isLoading: false,
          isLoaded: true,
          depositSlipDetail: [],
          error: res.errorMessage || errorMsg
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line
      console.log('Exception while setDepositSlipDetailsForModalAction ', res);
      dispatch(
        setDepositSlipDetailsForModalAction({
          isLoading: false,
          isLoaded: true,
          depositSlipDetail: [],
          error: errorMsg
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const cancelDepositSlipDetailAction = obj => (dispatch: Function) => {
  dispatch(
    getDashboardDataAction({
      isCancellationLoading: true
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'cancelDepositSlip',
    pathVariables: [{ key: '{id}', val: obj.id }],
    replaceParamsArr: [{ key: 'reason', val: obj.reason }],
    method: 'DELETE',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getDashboardDataAction({
            isCancellationLoading: false,
            cancellationSuccess: true
          })
        );
        toastr.success('Success', `Deposit Slip cancelled`);
      } else if (res.status === 'FAILURE') {
        dispatch(
          getDashboardDataAction({
            isCancellationLoading: false
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getDashboardDataAction({
          isCancellationLoading: false
        })
      );
      toastr.error('Failure', res.errorMessage, { timeout: 3000 });
    },
    catchCb: res => {
      dispatch(
        getDashboardDataAction({
          isCancellationLoading: false
        })
      );
      toastr.error('Failure', res.errorMessage, { timeout: 3000 });
    }
  };

  return makeApiCall(requestObj);
};

export const submitBankSlipDetailAction = (
  requestData: Object,
  cb: Function
) => (dispatch: Function) => {
  dispatch(
    getDashboardDataAction({
      submitBankSlipModalLoader: true
    })
  );
  let formData = new FormData();
  if (requestData.bankReceiptFile) {
    formData.append('bankReceiptFile', requestData.bankReceiptFile);
  }
  formData.append('depositSlipId', requestData.depositSlipId);
  formData.append('bankSlipNumber', requestData.bankSlipNumber || '');

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'bankSlip',
    postFormData: true,
    data: formData,
    contentType: undefined,
    pathVariables: [],
    method: 'POST',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getDashboardDataAction({
            submitBankSlipModalLoader: false
          })
        );
        cb();
        toastr.success('Success', `Bank Slip submitted successfully`);
      } else if (res.status === 'FAILURE') {
        dispatch(
          getDashboardDataAction({
            submitBankSlipModalLoader: false
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getDashboardDataAction({
          submitBankSlipModalLoader: false
        })
      );
      toastr.error('Failure', res.errorMessage, { timeout: 3000 });
    },
    catchCb: res => {
      dispatch(
        getDashboardDataAction({
          submitBankSlipModalLoader: false
        })
      );
      toastr.error('Failure', res.errorMessage, { timeout: 3000 });
    }
  };

  return makeApiCall(requestObj);
};
